import { FormProvider, useForm } from "react-hook-form";

import { ScreenWrapper } from "@/features/get-steps";
import useGetBranch from "@/shared/hooks/useGetBranch";
import { useSteps } from "@/shared/hooks/useGetSteps";
import { PossibleStepsTypes } from "@/shared/lib/step.constants";
import { zodResolver } from "@hookform/resolvers/zod";
import dayjs from "dayjs";
import { FormSchema, type FormValues } from "../model/form.schema";
import DetailsScreen from "./DetailsScreen/DetailsScreen";
import EmployeeScreen from "./EmployeeScreen/EmployeeScreen";
import FinishScreen from "./FinishScreen/FinishScreen";
import MainScreen from "./MainScreen/MainScreen";
import ScheduleScreen from "./ScheduleScreen/ScheduleScreen";
const HomePage = () => {
  // ! ||--------------------------------------------------------------------------------
  // ! ||                                      hooks
  // ! ||--------------------------------------------------------------------------------
  const branchId = Number(location.pathname.split("/").at(-1));

  const { branchData } = useGetBranch();
  const { steps } = useSteps();

  const methods = useForm<FormValues>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      branch_id: branchId,
      duration: branchData?.branch.online_booking_durations[0] || 30,
      date: dayjs(),
    },
  });

  // ! ||--------------------------------------------------------------------------------
  // ! ||                                      logic
  // ! ||--------------------------------------------------------------------------------

  const currStep = steps.find((step) => step.status === "process");
  const isFinished = !!steps.every((step) => step.status === "finish");

  // ! ||--------------------------------------------------------------------------------
  // ! ||                                      render
  // ! ||--------------------------------------------------------------------------------

  return (
    <FormProvider {...methods}>
      {!currStep && !isFinished && <MainScreen />}
      {currStep && (
        <ScreenWrapper>
          {currStep.type === PossibleStepsTypes.dateTime && <ScheduleScreen />}
          {currStep.type === PossibleStepsTypes.employee && <EmployeeScreen />}
          {currStep.type === PossibleStepsTypes.details && <DetailsScreen />}
        </ScreenWrapper>
      )}
      {isFinished && <FinishScreen />}
    </FormProvider>
  );
};
export default HomePage;
